import React, { Component } from "react";
import { Select, DatePicker, message, TimePicker } from "antd";
import moment from "moment";
import { map } from "lodash";
import * as yup from "yup";
import smile from '../../../../../Assets/images/smile.png';
import sad from '../../../../../Assets/images/sad.png';
import confused from '../../../../../Assets/images/confused.png';
const { Option } = Select;

class LogCall extends Component {
  state = {
    logDate: '',
    logTime: '',
    notes: '',
    reason: '',
    reasonText: '',
    next_callback_date: '',
    next_callback_time: '',
    compliment: '',
    contact_method: '',
    representative: '',
    reqCallback: '',
    loader: true,
    callLog: {},
    representativeList:{},
    errors: {},
  }

  componentDidMount = () => {
    this.getLogList();
    this.props.getRepresentativeList();
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // get call logs
    if (Object.keys(nextProps?.CallLog?.logList).length > 0) {
      this.setState({ callLog: nextProps?.CallLog?.logList, loader: false });
    }

    /**
     * AUTHOR: Ritesh Solanki
     * <DP-3487>Log a Call - Redesign</DP-3487>
     * Get list of representative 
     */
    if (Object.keys(nextProps?.RepresentativeList?.representativeList).length > 0 && JSON.stringify(nextProps?.RepresentativeList?.representativeList) !== JSON.stringify(this.state?.representativeList)) {
      this.setState({ representativeList: nextProps?.RepresentativeList?.representativeList, loader: false });
      this.loggedInUserDetails();
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   */
  getLogList = () => {
    const { getCallLogList } = this.props;
    this.setState({ loader: true });
    if (this?.props?.query?.detail?.user_uuid) {
      getCallLogList && getCallLogList({ user__uuid: this.props.query.detail.user_uuid }) // get call logs
    } else {
      getCallLogList && getCallLogList({ proposal__uuid: this?.props?.query?.detail?.uuid }) // get call logs
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   */
  loggedInUserDetails = () => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    if (user) {
      this.setState({
        representative: user?.user?.uuid,
        logDate: moment(),
        logTime: moment()
      });
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   * on text change
   */
  onTextChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   */
  validate = () => {
    const { logDate, logTime, representative, reason, notes, reasonText } = this.state;
    const schema = yup.object().shape({
      logDate: yup.string().required('Date is required.'),
      logTime: yup.string().required('Time is required.'),
      representative: yup.string().required('Representative is required.'),
      reason: yup.string().required('Proposal is required.'),
      reasonText: (reason === "Other" && !reasonText) ? yup.string().required('Reason is required.') : null,
      notes: yup.string().required('Note is required.'),
    })
    const data = { logDate, logTime, representative, reason, notes };
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({ errors: {} });
      this.onSaveNote();
    }).catch((error) => {

      let err_data = {};
      map(error.inner, (item) => { err_data[item.path] = item.message });
      this.setState({ errors: err_data });
    })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   */
  onSaveNote = () => {
    const { logDate, logTime, representative, reasonText, reason, notes, next_callback_date, next_callback_time, compliment } = this.state;
    this.setState({ loader: true });
    let params = {
      time_to_call: `${moment(logDate).format("YYYY-MM-DD")} ${moment(logTime).format("hh:mm")}`,
      representative: `${representative}`,
      notes: `${notes}`,
      next_callback: (next_callback_date && next_callback_time) ? `${moment(next_callback_date).format("YYYY-MM-DD")} ${moment(next_callback_time).format("hh:mm")}` : null,
      compliment: `${compliment}`,
      reason:  `${reason}` === 'Other' ? `${reasonText}` : `${reason}`,
      user: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid,
      proposal: this?.props?.query?.detail?.uuid,
      created_by_details: {
        uuid: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid
      }
    }
    this.props.addCallLog(params).then(response => {
      this.setState({ loader: true });
      this.getLogList();
      message.success("Call logged successfully.", 10);
      this.onClear();
    }).catch(error => {
      message.error("Error occur while saving call log details..", 10);
    });
    this.setState({ loader: false });
  };

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   */
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   */
  onClear = () => {
    this.setState({
      notes: '',
      next_callback: '',
      compliment: '',
      reason: '',
      reasonText: '',
      errors: {}
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487>Log a Call - Redesign</DP-3487>
   */
  cancel = () => {
    this.setState({
      logDate: '',
      logTime: '',
      notes: '',
      reason: '',
      compliment: '',
      next_callback_date:'',
      next_callback_time:'',
      contact_method: '',
      representative: '',
      reqCallback: '',
      errors: {}
    });
    this.props.collapse();
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3760></DP-3760>
   */
  callbackComplete = (item, is_callback) => {
    item['callback_flag'] = is_callback;
    Promise.allSettled([
      this.props.updateCallLog(item.uuid, { 
        callback_flag: is_callback
      })
    ]).then(result => {
      const isFulfilled = result.filter(x => x.status === "fulfilled");
      if (isFulfilled?.length > 0) {
        message.success("Call logged successfully.", 10);
      } else {
        message.error("Error occur while call logged.", 10);
      }
    });
  }
  
  render() {
    const { logDate, logTime, notes, reason, reasonText, compliment, next_callback_date, next_callback_time, representative, callLog, errors, representativeList, } = this.state;
    return (
      <div>
        <div className="form-group">
          <div className="fitem mb-0">
            <label>Date & Time of Call <sup>*</sup></label>
            <div className="row">
              <div className="col-6">
                <div className="fitem">
                  <DatePicker
                    style={{ 'width': '100%' }}
                    format="YYYY-MM-DD"
                    suffixIcon={<i className="las la-calendar"></i>}
                    allowClear={true}
                    placeholder={'mm/dd/yyyy'}
                    defaultValue={moment()}
                    value={logDate || undefined}
                    onChange={(e) => {
                      if (e) {
                        this.setState({logDate: e});
                      } else {
                        this.setState({logDate: null});
                      }
                    }}
                  />
                  {errors?.['logDate'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['logDate']}</label> : ''}
                </div>
              </div>
              <div className="col-6">
                <div className="fitem">
                  <TimePicker
                    className="swhite"
                    format={'h:mm A'}
                    placeholder={'--:-- AM/PM'}
                    allowClear={true}
                    defaultValue={moment()}
                    value={logTime || undefined}
                    minuteStep={15}
                    onChange={(e) => {
                      if (e) {
                        this.setState({logTime: e});
                      } else {
                        this.setState({logTime: null});
                      }
                    }}
                  />
                  {errors?.['logTime'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['logTime']}</label> : ''}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="fitem">
                <label>Representative <sup>*</sup></label>
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder={"Representative"}
                  value={representative || undefined}
                  onChange={(e) => {
                    if (e) {
                      this.setState({representative: e});
                    } else {
                      this.setState({representative: null});
                    }
                  }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {map(representativeList, (item, index) => {
                    if (index > 0) {
                      return (
                        <Option key={index} value={item.uuid}>{item.name}</Option>
                      )
                    }
                  })}
                </Select>
                {errors?.['representative'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['representative']}</label> : ''}
              </div>
            </div>
            <div className="col-6">
              <div className="fitem">
                <label>Purpose of Call <sup>*</sup></label>
                <Select
                  name={"reason"}
                  placeholder="Reason"
                  value={reason || undefined}
                  onChange={(e) => this.onTextChange({ target: { name: 'reason', value: e } })}
                >
                  <Option value="Issue: Accounting">Issue: Accounting</Option>
                  <Option value="Issue: Operation">Issue: Operations</Option>
                  <Option value="Inquiry Residential Service">Inquiry Residential Service</Option>
                  <Option value="Inquiry Community Service">Inquiry Community Service</Option>
                  <Option value="Compliment">Compliment</Option>
                  <Option value="Other">Other</Option>
                </Select>
                {errors?.['reason'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['reason']}</label> : ''}
              </div>
            </div>
          </div>
          {reason === "Other" &&
          <div className="fitem">
            <label>Purpose of Call - Other <sup>*</sup></label>
            <input 
              type="text" 
              placeholder="Explain the purpose of the call" 
              value={reasonText || undefined}
              maxLength={30}
              onChange={(e) => {
                this.setState({ reasonText: e?.target?.value })
              }}
            />
            {errors?.['reasonText'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['reasonText']}</label> : ''}
          </div>}
          <div className="fitem plain-control">
            <textarea
              className="textarea-gray"
              rows="5"
              name="notes"
              type="text"
              maxLength={200}
              placeholder={"Add notes from the call here"}
              value={notes}
              onChange={(e) => this.onTextChange(e)} 
            />
            {errors?.['notes'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['notes']}</label> : ''}
          </div>
          <div className="row">
            <div className="col-6">
              <div className="fitem">
                <span className="fs-13 d-block mb-5">Customer Satisfaction Score</span>
                <div className="rating flex mb-20 justify-content-start">
                  <img src={smile} alt="" style={{width:'26px', marginRight: '15px'}} onClick={() => this.onTextChange({ target: { name: 'compliment', value: compliment === "happy" ? "" : 'happy' } })} />
                  <img src={confused} alt="" style={{width:'26px', marginRight: '15px'}} onClick={() => this.onTextChange({ target: { name: 'compliment', value: compliment === "neutral" ? "" : 'neutral' } })} />
                  <img src={sad} alt="" style={{width:'26px'}} onClick={() => this.onTextChange({ target: { name: 'compliment', value: compliment === "sad" ? "" : 'sad' } })} />
                </div>
              </div>
            </div>
          </div>
          <div className="fitem mb-0">
            <label>Date & Time of Callback (Optional) <sup>*</sup></label>
            <div className="row">
              <div className="col-6">
                <div className="fitem">
                  <DatePicker
                    style={{ 'width': '100%' }}
                    format="MM-DD-YYYY"
                    placeholder={'mm/dd/yyyy'}
                    suffixIcon={<i className="las la-calendar"></i>}
                    allowClear={true}
                    value={next_callback_date || undefined}
                    onChange={(e) => {
                      if (e) {
                        this.setState({next_callback_date: e});
                      } else {
                        this.setState({next_callback_date: e});
                      }
                    }}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="fitem">
                  <TimePicker
                    className="swhite"
                    format={'h:mm A'}
                    placeholder={'--:-- AM/PM'}
                    allowClear={true}
                    value={next_callback_time || undefined}
                    minuteStep={15}
                    disabled={!next_callback_date}
                    onChange={(e) => {
                      if (e) {
                        this.setState({next_callback_time: e});
                      } else {
                        this.setState({next_callback_time: e});
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="call-history-wrap">
          <h5>Call History</h5>
          <div>
            {map(callLog?.results, (item, index) => {
              return (
                <div className="ch-block" key={index}>
                  <div className="flex ai-center mb-10 justify-content-start">
                    {item?.compliment === "happy" && <img src={smile} alt="" style={{width:'16px', marginRight: '8px'}} />}
                    {item?.compliment === "neutral" && <img src={confused} alt="" style={{width:'16px', marginRight: '8px'}} />}
                    {item?.compliment === "sad" && <img src={sad} alt="" style={{width:'16px', marginRight: '8px'}} />}
                    <div className="flex fs-13">
                      <strong className="mr-5"> {item?.reason}</strong>
                      <span>{item?.time_to_call ? moment(item?.time_to_call).format("MMM DD, YYYY hh:mm A") : '-'}</span>
                    </div>
                  </div>
                  <p className="mb-8 text-wrap">{item?.notes}</p>
                  <div className="flex ai-center mb-8">
                    <div className="flex">
                      <strong className="mr-5">Scheduled Callback:</strong>
                      <span>{item?.next_callback ? moment(item?.next_callback).format("MMM DD, YYYY hh:mm A") : '-'}</span>
                    </div>
                  </div>
                  <div className="fitem-check mb-4">
                    <input 
                      type="checkbox" 
                      className="fitem-ck-input" 
                      id={`checkboxPhone${index}`} 
                      name="phone0" 
                      value={item.callback_flag}
                      checked={item.callback_flag}
                      onChange={(e) => {
                        this.callbackComplete(item, e?.target?.checked);
                      }}
                    />
                    <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt">Callback Complete</label>
                  </div>
                  <small className="opacity-5 color-22232A">Performed by {item?.representative}, Logged by {item?.logged_by_user}</small>
                </div>)
            })}
          </div>
        </div>
        <div className="footer">
          <button className="btn btn-brand btn-bdr" onClick={() => this.cancel()}>Cancel</button>
          <button className="btn btn-warning" onClick={() => this.validate()}>Log Call</button>
        </div>
      </div>
      
    )
  }
}

export default LogCall;